import { Download1Stroke, EyeStroke, Pencil1Stroke, PlusStroke, Trash3Stroke } from '@lineiconshq/free-icons';
import { FileDown, RefreshCw, Table } from 'lucide-react';
import { ActionBarV2, ActionButtonV2, ExternalLink, MenuButtonV2 } from '@/components/custom/erp';
import ADMIN_URL from '@/constants/admin-url';

interface ActionBarProps {
  onAddClick: () => void;
  onEditClick: () => void;
  isEditDisabled?: boolean;
  onViewClick: () => void;
  isViewDisabled?: boolean;
}

export const ActionBar = ({
  onAddClick,
  onEditClick,
  isEditDisabled = true,
  onViewClick,
  isViewDisabled = true
}: ActionBarProps) => (
  <ActionBarV2
    titleComponent={
      <div>
        <h1 className='text-xl font-bold'>Thuế suất thuế nhập khẩu</h1>
        <span className='flex items-center justify-start text-xs font-semibold text-gray-500'>
          <div className='mr-1 size-2 rounded-full bg-red-500' />
          <ExternalLink href={ADMIN_URL.THUE_SUAT_THUE_NHAP_KHAU} />
        </span>
      </div>
    }
  >
    <ExternalLink href={`${ADMIN_URL.THUE_SUAT_THUE_NHAP_KHAU}/add`}>
      <ActionButtonV2 icon={PlusStroke} title='Thêm' variant='primary' />
    </ExternalLink>
    <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditClick} disabled={isEditDisabled} />
    <ActionButtonV2 icon={Trash3Stroke} title='Xoá' variant='destructive' onClick={() => {}} />
    <ActionButtonV2 icon={Download1Stroke} title='Sao chép' onClick={() => {}} />
    <ActionButtonV2 icon={EyeStroke} title='Xem' onClick={onViewClick} disabled={isViewDisabled} />
    <MenuButtonV2
      title='Khác'
      items={[
        {
          title: 'Refresh',
          icon: RefreshCw,
          onClick: () => {},
          group: 0
        },
        {
          title: 'Cố định cột',
          icon: Table,
          onClick: () => {},
          group: 0
        },
        {
          title: 'Kết xuất dữ liệu',
          icon: FileDown,
          onClick: () => {},
          group: 1
        }
      ]}
    />
  </ActionBarV2>
);
